import React, {FC} from "react";
import {Alert as MuiAlert, Box, styled} from "@mui/material";
import {Button as MuiButton} from "@mui/material";
import * as types from "../../../../../../constants";
import {useDispatch} from "react-redux";
import Typography from "@mui/material/Typography";

const Alert = styled(MuiAlert)`
  //padding: 5px 10px;
  display: flex;
  background-color: #0f5165;
  .MuiAlert-message {
    padding: 2px 0
  }
`

const Button = styled(MuiButton)`
  text-transform: unset;
  color: #FFF;
  word-break: break-all;
`

type PropsType = {
  companyAPIKey: string
}

const AlertCompanyAPIKey: FC<PropsType> = ({companyAPIKey}) => {
  const dispatch = useDispatch()
  const handleCopy = () => {
    navigator.clipboard.writeText(companyAPIKey)
    dispatch({
      type: types.ADD_TOAST,
      payload: {type: 'success', message: 'The key was copied'}
    })
  }

  return (
    <Alert icon={false} variant={'filled'} severity={'info'}>
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
        <Typography fontSize={'0.875rem'} fontWeight={'bold'}>Current Company API Key:</Typography>
        <Box ml={1}><Button onClick={handleCopy}>{companyAPIKey}</Button></Box>
      </Box>
    </Alert>
  )
}

export default AlertCompanyAPIKey